import { call, put, takeLatest } from "redux-saga/effects";
import { donViHanhChinhApi } from "../../../api/category/donViHanhChinhApi";
import { IBaseRespone } from "../../../model/respone/IBaseRespone";
import { rootActions } from "../../actions/rootActions";
import { eDonViHanhChinhActionIds } from "../../action-types/category/IDonViHanhChinhActions";

export function* donViHanhChinhSaga(): any {
  yield takeLatest(eDonViHanhChinhActionIds.LOAD_START, loadWorker);
}

function* loadWorker(): any {
  const res: IBaseRespone = yield call(donViHanhChinhApi.SelectAll);
  if (res.is_success) {
    yield put(rootActions.category.donViHanhChinh.LOAD_SUCCESS(res.data));
  } else {
    yield put(
      rootActions.category.donViHanhChinh.LOAD_ERRR(res.message ?? "Có lỗi")
    );
  }
}
